// Familles de cultures avec nuances individuelles
// - label + couleur : utilisés pour la légende (familles de haut niveau uniquement)
// - nuances : chaque entrée = une couleur distincte sur la carte
//   culturesIds = liste des IDs de cultures partageant cette nuance

export const famillesCultures = [
  {
    label: "Céréales à paille",
    couleur: "#FFC107",
    nuances: [
      { couleur: "#FFD54F", culturesIds: [102] }, // BLE TENDRE
      { couleur: "#FF9800", culturesIds: [101] }, // BLE DUR
      { couleur: "#CDDC39", culturesIds: [105] }, // ORGE
      { couleur: "#D4A017", culturesIds: [110] }, // TRITICALE
      { couleur: "#FFE082", culturesIds: [118, 151, 160, 185, 301] }, // AVOINE, SEIGLE, BLE DE FORCE, EPEAUTRE, METEIL
    ],
  },
  {
    label: "Céréales d'été",
    couleur: "#009688",
    nuances: [
      { couleur: "#009688", culturesIds: [104] }, // MAÏS
      { couleur: "#4DB6AC", culturesIds: [108] }, // SORGHO
      { couleur: "#00796B", culturesIds: [175] }, // MAÏS DOUX
      { couleur: "#80CBC4", culturesIds: [139, 196, 150, 195, 263] }, // MAÏS POP CORN, MILLET, SARRASIN, MOHA, SORGHO FOURRAGER
    ],
  },
  {
    label: "Oléagineux",
    couleur: "#FF5722",
    nuances: [
      { couleur: "#FF5722", culturesIds: [109] }, // TOURNESOL
      { couleur: "#F06292", culturesIds: [103] }, // COLZA
      { couleur: "#7CB342", culturesIds: [107] }, // SOJA
      { couleur: "#FF8A65", culturesIds: [134] }, // LIN
      { couleur: "#FFCC80", culturesIds: [193, 198, 126, 165, 305, 147, 111, 261] }, // LIN FIBRES, MOUTARDE, CHOU, NAVET, + RADIS, CHIA, CAMELINE
    ],
  },
  {
    label: "Protéagineux",
    couleur: "#2196F3",
    nuances: [
      { couleur: "#2196F3", culturesIds: [106] }, // POIS
      { couleur: "#1565C0", culturesIds: [112] }, // FEVEROLE
      { couleur: "#64B5F6", culturesIds: [133] }, // LENTILLE
      { couleur: "#0288D1", culturesIds: [136] }, // LUZERNE
      { couleur: "#42A5F5", culturesIds: [169] }, // POIS CHICHE
      { couleur: "#90CAF9", culturesIds: [132, 135, 159, 218, 232, 149, 170, 206, 329, 330] }, // HARICOT, LUPIN, TREFLE, VESCE, GESSE, SAINFOIN, FENUGREC, POIS (petits), LOTIER, MELILOT
      { couleur: "#B3E5FC", culturesIds: [331, 332, 333, 337] }, // Mélanges légumineuses/protéagineux
    ],
  },
  {
    label: "Prairies",
    couleur: "#673AB7",
    nuances: [
      { couleur: "#673AB7", culturesIds: [248] }, // PRAIRIE PERMANENTE
      { couleur: "#9575CD", culturesIds: [253] }, // PRAIRIE TEMPORAIRE
      { couleur: "#B39DDB", culturesIds: [127, 129, 146, 148, 171, 336] }, // DACTYLE, FETUQUE, RAY GRASS ANGLAIS, RAY GRASS ITALIE, Mélange Lég.Gram.fourr.
    ],
  },
  {
    label: "VAM",
    couleur: "#795548",
    nuances: [
      { couleur: "#5D4037", culturesIds: [217] }, // VIGNE-CUVE
      { couleur: "#6D4C41", culturesIds: [254] }, // VIGNE-TABLE
      { couleur: "#8D6E63", culturesIds: [207] }, // PRUNE D'ENTE
      { couleur: "#A1887F", culturesIds: [216, 199, 262, 180, 343, 344, 345] }, // VERGERS, NOISETTE, NOIX, Châtaigne, CERISE, PECHE, OLIVERAIE
      { couleur: "#BCAAA4", culturesIds: [116, 117, 120, 124, 140, 141, 143, 145, 167, 186, 187, 191, 202, 213, 306, 327, 328] }, // Maraîchage
      { couleur: "#D7CCC8", culturesIds: [194, 339, 340, 341, 342, 338, 347] }, // PPAM et autres pérennes
    ],
  },
  {
    label: "Autres / PAC",
    couleur: "#9E9E9E",
    nuances: [
      { couleur: "#616161", culturesIds: [244, 245, 246, 346, 249] }, // Jachères
      {
        couleur: "#9E9E9E",
        culturesIds: [131, 219, 220, 221, 237, 240, 241, 242, 243, 250, 251, 252, 256, 300], // Surfaces pastorales, bandes, PAC
      },
      {
        couleur: "#BDBDBD",
        culturesIds: [
          125, 128, 138, 142, 161, 166, 176, 177, 178, 179, 181, 182, 184,
          188, 189, 190, 192, 197, 200, 201, 203, 204, 205, 209, 210, 211,
          212, 214, 215, 233, 234, 235, 238, 247, 260,
        ], // Divers, autres cultures
      },
    ],
  },
];

// Couleur par défaut pour les cultures non référencées
const COULEUR_DEFAUT = "#BDBDBD";

// Recherche la couleur d'une culture par son ID
export const getCouleurCulture = (cultureId) => {
  for (const famille of famillesCultures) {
    for (const nuance of famille.nuances) {
      if (nuance.culturesIds.includes(cultureId)) {
        return nuance.couleur;
      }
    }
  }
  return COULEUR_DEFAUT;
};

// Rétro-compatibilité : export sous l'ancien nom pour la légende
// Chaque famille expose { label, couleur } comme avant
export const couleursCultures = famillesCultures.map(({ label, couleur }) => ({
  label,
  couleur,
}));
